import { put, takeLatest, delay } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
// import { actionApiCall } from "helpers/api/ApiCalls";

function* paginationOrganizationsSaga({ payload }) {
    try {
        if (payload.dataType === "organizations") {
            yield put({
                type: ActionTypeConstants.LOAD_ORGANIZATIONS_SUCCESS,
                payload: {
                    page: payload.currentPage + 1,
                }
            });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "An issue occurred while loading organizations",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.SET_PAGINATION, paginationOrganizationsSaga);
}
